import { JSX } from 'react'
import {
  Abandoned,
  Approved,
  Competitor,
  Dead,
  Done,
  InProgress,
  Negative,
  None,
  OnHold,
  Positive,
  Reported,
  Waiting,
} from '@/assets/icons/statusIcons.tsx'

export type CustomIconsT =
  | 'reported'
  | 'inProgress'
  | 'done'
  | 'approved'
  | 'onHold'
  | 'abandoned'
  | 'waiting'
  | 'dead'
  | 'competitor'
  | 'positive'
  | 'negative'
  | 'none'

export const STATUS_ICONS: Record<CustomIconsT, JSX.Element> = {
  reported: <Reported />,
  inProgress: <InProgress />,
  done: <Done />,
  approved: <Approved />,
  onHold: <OnHold />,
  abandoned: <Abandoned />,
  waiting: <Waiting />,
  dead: <Dead />,
  competitor: <Competitor />,
  positive: <Positive />,
  negative: <Negative />,
  none: <None />,
}
export const DEFAULT_STATUS_ICON = 'none'
